<template>
  <el-dialog title="登录" width="30%" :visible.sync="visible" :close-on-click-modal="false"
    :close-on-press-escape="false" :show-close="showClose" @close="close">
    <div class="form-box">
      <account-login v-if="tab === 'account'" @success="handleLoginNext" @fail="loginFailed"></account-login>
      <phone-login v-if="tab === 'phone'" @success="handleLoginNext" @fail="loginFailed"></phone-login>
      <national-login v-if="tab === 'national'" @success="handleLoginNext" @fail="loginFailed"></national-login>
      <div v-if="!isChongQing && !isNationalTest">
        <span class="switch-link" :style="'color:' + theme.themeColor" v-if="tab === 'account'"
          @click="change('phone')">手机号登录</span>
        <span v-else class="switch-link" :style="'color:' + theme.themeColor"
          @click="change('account')">账号登录</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import AccountLogin from './AccountLogin'
import PhoneLogin from './PhoneLogin'
import NationalLogin from './NationalLogin'
import { loginEvent } from '@/utils/sensor'
import { getNatialPath } from '@/utils/common'
import * as Sentry from '@sentry/browser'

export default {
  components: {
    ElDialog: Dialog,
    AccountLogin,
    PhoneLogin,
    NationalLogin
  },
  props: {
    visible: Boolean,
    showClose: Boolean
  },
  data() {
    return {
      tab: ''
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    testInfo() {
      return this.$store.state.testInfo
    },
    theme() {
      return this.$store.state.theme
    },
    // 是否是重庆大赛
    isChongQing() {
      const path = sessionStorage.getItem('path')
      const arr = ['chongqingceshi', 'chongqing', 'cqmn']
      return arr.includes(path)
    },
    // 是否是新国赛
    isNationalTest() {
      const natialPath = getNatialPath(CONFIG.env)
      if (window.location.href.indexOf(natialPath) !== -1) {
        return true
      }
      return false
    }
  },
  methods: {
    change(item) {
      this.tab = item
    },
    close() {
      this.$emit('close')
    },
    // 登录成功后处理
    async handleLoginNext() {
      const userInfo = await this.$auth('get_profile')
      this.$store.commit('HAS_TOKEN', true)
      this.$store.commit('SET_USER', userInfo)
      localStorage.setItem('user_id', userInfo.id)
      loginEvent(userInfo)
      this.$emit('success')
      Sentry.captureEvent({
        message: '登录弹窗，登录成功',
        extra: userInfo.id
      })
    },
    loginFailed(e) {
      Sentry.captureEvent({
        message: '登录弹窗，登录失败',
        extra: e
      })
    }
  },
  async mounted() {
    if (this.isNationalTest) {
      this.tab = 'national'
    } else {
      this.tab = 'account'
    }
  }
}
</script>

<style lang="scss" scoped>
.form-box {
  width: 360px;
  margin: 0 auto;
  padding-bottom: 20px;
}

.switch-link {
  cursor: pointer;
  display: inline-block;
  color: $themeColor;
  font-size: 14px;
  margin-top: 20px;
}
</style>
